module.exports = "/call-frontend/img/icon_delete_outline.99b7fb18.svg";